import {
  KalturaAggregationCountFilter,
  KalturaChannelFilter,
  KalturaFavoriteFilter,
  KalturaListGroupsRepresentativesFilter,
  KalturaSearchAssetFilter,
  KalturaPersonalListSearchFilter,
  KalturaBookmarkFilter,
  KalturaUserAssetRuleFilter,
  KalturaPersonalListFilter,
} from './filters';
import {
  KalturaAssetMetaOrTagGroupBy,
  KalturaDetachedResponseProfile,
  KalturaDynamicOrderBy,
  KalturaFilterPager,
  KalturaOnDemandResponseProfile,
} from './objects';

function createFactory<T extends { objectType: unknown }>(objectType: T['objectType']) {
  return function createObject(args: Omit<T, 'objectType'>) {
    return {
      objectType,
      ...args,
    };
  };
}

// Objects

export const createAssetMetaOrTagGroupBy = createFactory<KalturaAssetMetaOrTagGroupBy>('KalturaAssetMetaOrTagGroupBy');
export const createDynamicOrderBy = createFactory<KalturaDynamicOrderBy>('KalturaDynamicOrderBy');
export const createDetachedResponseProfile = createFactory<KalturaDetachedResponseProfile>(
  'KalturaDetachedResponseProfile',
);
export const createOnDemandResponseProfile = createFactory<KalturaOnDemandResponseProfile>(
  'KalturaOnDemandResponseProfile',
);
export const createPager = createFactory<KalturaFilterPager>('KalturaFilterPager');

// Filters
export const createAggregationCountFilter = createFactory<KalturaAggregationCountFilter>(
  'KalturaAggregationCountFilter',
);
export const createBookmarkFilter = createFactory<KalturaBookmarkFilter>('KalturaBookmarkFilter');
export const createChannelFilter = createFactory<KalturaChannelFilter>('KalturaChannelFilter');
export const createFavoriteFilter = createFactory<KalturaFavoriteFilter>('KalturaFavoriteFilter');
export const createListGroupsRepresentativesFilter = createFactory<KalturaListGroupsRepresentativesFilter>(
  'KalturaListGroupsRepresentativesFilter',
);
export const createSearchAssetFilter = createFactory<KalturaSearchAssetFilter>('KalturaSearchAssetFilter');
export const createPersonalListFilter = createFactory<KalturaPersonalListFilter>('KalturaPersonalListFilter');
export const createPersonalListSearchFilter = createFactory<KalturaPersonalListSearchFilter>(
  'KalturaPersonalListSearchFilter',
);
export const createUserAssetRuleFilter = createFactory<KalturaUserAssetRuleFilter>('KalturaUserAssetRuleFilter');
